const summerCountdownPage = document.querySelector('.summer-promo--countdown')

if(summerCountdownPage) {
    const countdownItems = summerCountdownPage.querySelectorAll('.numbers-holder');
    const countdownHeading = summerCountdownPage.querySelector('.js-summer-promo-countdown-heading');
    const countdownContent = summerCountdownPage.querySelectorAll('.lbk-rich-text-component');
    const countdownBtns = summerCountdownPage.querySelectorAll('.summer-btn');
    const countdownLogoWithText = summerCountdownPage.querySelector('.js-summer-promo-countdown-animation-logo-with-text');
    const countdownHaloEffect = summerCountdownPage.querySelector('.js-summer-promo-countdown-animation-halo-effect');
    const countdownRotatingObject = summerCountdownPage.querySelector('.js-summer-promo-countdown-animation-rotating-object');

    function animateElements(elements, delayStart, className, stagger = 150) {
        setTimeout(() => {
            elements.forEach((el, index) => {
                setTimeout(() => {
                    el.classList.add(className);
                }, index * stagger);
            });
        }, delayStart);
    }


    window.addEventListener('load', () => {
        if (summerCountdownPage) {
            if (countdownItems.length > 0) {
                animateElements(countdownItems, 1500, 'pop-in');
            }

            if (countdownHeading) {
                setTimeout(() => {
                    countdownHeading.classList.add('reveal-bottom-to-top');
                }, 1600);
            }

            if (countdownContent.length > 0) {
              animateElements(countdownContent, 1750, 'pop-in');
            }

            if (countdownBtns.length > 0) {
                animateElements(countdownBtns, 1950, 'pop-in');
            }

            if(countdownLogoWithText) {
                setTimeout(() => {
                    countdownLogoWithText.classList.add('start-animation');
                }, 500);
            }

            if(countdownHaloEffect) {
                setTimeout(() => {
                    countdownHaloEffect.classList.add('start-animation');
                }, 500);

                setTimeout(() => {
                    countdownHaloEffect.classList.add('animate-after-fade');
                }, 2500);
            }

            if(countdownRotatingObject) {
                setTimeout(() => {
                    countdownRotatingObject.classList.add('start-animation');
                }, 500);
            }
        }
    });
}
